// Sürükle-bırak sıralama kopyaları (Finar rev-2 #4b/#12b/#14) — TEK kaynak; `KPI_COPY.reorder`
// olarak da açılır (kpi-ui.ts 600 satırı aştığı için ayrı dosya). DR12: durum kodu/tavan yok.

export const KPI_REORDER_COPY = {
  /** sürüklenebilir satırın (Veri Yönetimi) ve katalog tutamacının aria-describedby ipucu */
  hint: "Sürükleyin ya da ↑↓ ile taşıyın",
  saved: "Sıra kaydedildi",
  failed: "Sıra kaydedilemedi; önceki sıra geri yüklendi",
  /** hata bandını kapat */
  dismiss: "Kapat",
  /** tutamaç sütunu başlığı ve düğme etiketi */
  grip: "Sırayı değiştir",
  gripAria: (label: string): string => `${label}: sırayı değiştir`,
} as const;
